import { Grid, Typography } from '@mui/material'
import { FC, useContext } from 'react'

import { VehicleDetailContext } from '../../providers/VehicleDetailProvider/VehicleDetailProvider'
import { getVehicleInfo } from '../../utils/getVehicleInfo'
import { labels } from './Labels'

interface Props {}

export const VehicleDetailPanel: FC<Props> = () => {
  const { oldVehicleInfo } = useContext(VehicleDetailContext)

  return (
    <>
      <Grid direction="row" container aria-label="vehicleDetailPanel">
        {[
          'vin',
          'licensePlate',
          'registeredState',
          'mileage',
          'color',
          'name',
          'year'
        ].map((name) => (
          <Grid item key={name} xs={6} aria-label="vehicleDetailField">
            <Grid container>
              <Grid item xs={4} key={name + 'title'}>
                <Typography
                  variant="subtitle1"
                  aria-label="vehicleDetailFieldTitle">
                  {labels[name]}
                </Typography>
              </Grid>
              <Grid item xs={8} key={name + 'value'}>
                {oldVehicleInfo && (
                  <Typography aria-label="vehicleDetailFieldContent">
                    {getVehicleInfo(oldVehicleInfo, name)}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        ))}
        {['make', 'model', 'subModel', 'engine'].map((name) => (
          <Grid item key={name} xs={6} aria-label="vehicleDetailField">
            <Grid container>
              <Grid item xs={4} key={name + 'title'}>
                <Typography
                  variant="subtitle1"
                  aria-label="vehicleDetailFieldTitle">
                  {labels[name]}
                </Typography>
              </Grid>
              <Grid item xs={8} key={name + 'value'}>
                {oldVehicleInfo && (
                  <Typography aria-label="vehicleDetailFieldContent">
                    {getVehicleInfo(oldVehicleInfo, name)}
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Grid direction="row" container aria-label="vehicleDetailPanel">
        {['nextInspectionDate', 'nextOilServiceDate'].map((name) => (
          <Grid item key={name} xs={6} aria-label="vehicleDetailField">
            <Grid container>
              <Grid item xs={4} key={name + 'title'}>
                <Typography
                  variant="subtitle1"
                  aria-label="vehicleDetailFieldTitle">
                  {labels[name]}
                </Typography>
              </Grid>
              <Grid item xs={8} key={name + 'value'}>
                <Typography aria-label="vehicleDetailFieldContent">
                  {getVehicleInfo(oldVehicleInfo, name)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}

        {['nextOilServiceMileage'].map((name) => (
          <Grid item key={name} xs={6} aria-label="vehicleDetailField">
            <Grid container>
              <Grid item xs={4} key={name + 'title'}>
                <Typography
                  variant="subtitle1"
                  aria-label="vehicleDetailFieldTitle">
                  {labels[name]}
                </Typography>
              </Grid>
              <Grid item xs={8} key={name + 'value'}>
                <Typography aria-label="vehicleDetailFieldContent">
                  {getVehicleInfo(oldVehicleInfo, name)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  )
}
